import React, { useEffect, useState, useRef } from 'react';
import { Download, Globe, Shield, Heart } from 'lucide-react';
import { trackAddToCart } from '../../utils/pixel';
function useInView(threshold = 0.1) {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setInView(true);
    }, {
      threshold
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);
  return {
    ref,
    inView
  };
}
const trustBadges = [{
  icon: Download,
  label: 'Descarga inmediata'
}, {
  icon: Globe,
  label: '100% en español'
}, {
  icon: Shield,
  label: 'Garantía de satisfacción'
}, {
  icon: Heart,
  label: 'Hecho por mamás latinas'
}];
export function CTASection() {
  const {
    ref,
    inView
  } = useInView();
  const handleBuyClick = () => {
    trackAddToCart();
    window.location.href = 'https://eficienciadigital.ca/';
  };
  return <section id="cta-section" className="py-20 px-6 relative overflow-hidden" style={{
    background: 'linear-gradient(135deg, var(--color-burgundy) 0%, #5A1E2C 50%, var(--color-text-dark) 100%)'
  }} data-id="element-1">
      {/* Decorative circles */}
      <div className="absolute top-0 right-0 w-96 h-96 rounded-full opacity-10 pointer-events-none" style={{
      background: 'radial-gradient(circle, var(--color-terracotta-light), transparent 70%)',
      transform: 'translate(30%, -30%)'
    }} data-id="element-2" />
      <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full opacity-10 pointer-events-none" style={{
      background: 'radial-gradient(circle, var(--color-gold), transparent 70%)',
      transform: 'translate(-30%, 30%)'
    }} data-id="element-3" />

      <div ref={ref} className={`relative z-10 max-w-2xl mx-auto text-center transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} data-id="element-4">
        {/* Question */}
        <p className="font-serif text-xl sm:text-2xl italic leading-relaxed mb-10 opacity-90" style={{
        color: 'rgba(255,255,255,0.85)'
      }} data-id="element-5">
          "¿Cuándo fue la última vez que respiraste sin sentir que le quitas
          tiempo a tu hijo?"
        </p>

        {/* Price */}
        <div className="mb-8" data-id="element-6">
          <p className="font-sans text-sm font-medium uppercase tracking-widest mb-2 opacity-70" style={{
          color: 'var(--color-gold)'
        }} data-id="element-7">
            Tu inversión en ti misma:
          </p>
          <div className="flex items-baseline justify-center gap-3 mb-2" data-id="element-8">
            <span className="font-serif text-7xl sm:text-8xl font-black" style={{
            color: '#fff'
          }} data-id="element-9">
              $6.39
            </span>
          </div>
          <p className="font-serif text-lg italic" style={{
          color: 'var(--color-gold)'
        }} data-id="element-10">
            El precio de un café. El valor: tu salud mental.
          </p>
        </div>

        {/* CTA Button */}
        <button onClick={handleBuyClick} className="pulse-cta font-sans font-bold text-lg sm:text-xl px-10 py-5 rounded-full transition-all duration-200 hover:scale-105 active:scale-95 mb-10" style={{
        backgroundColor: '#fff',
        color: 'var(--color-terracotta)',
        boxShadow: '0 8px 32px rgba(0,0,0,0.3)'
      }} onMouseEnter={e => {
        e.currentTarget.style.backgroundColor = 'var(--color-cream)';
      }} onMouseLeave={e => {
        e.currentTarget.style.backgroundColor = '#fff';
      }} data-id="element-11">
          QUIERO MI GUÍA AHORA →
        </button>

        {/* Trust badges */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-12" data-id="element-12">
          {trustBadges.map(({
          icon: Icon,
          label
        }) => <div key={label} className="flex flex-col items-center gap-2 p-3 rounded-xl" style={{
          backgroundColor: 'rgba(255,255,255,0.08)'
        }} data-id="element-13">
              <Icon size={20} style={{
            color: 'var(--color-gold)'
          }} data-id="element-14" />
              <span className="font-sans text-xs text-center leading-tight" style={{
            color: 'rgba(255,255,255,0.8)'
          }} data-id="element-15">
                {label}
              </span>
            </div>)}
        </div>

        {/* Final emotional line */}
        <div className="pt-8 border-t border-white border-opacity-15" data-id="element-16">
          <p className="font-serif text-xl sm:text-2xl italic" style={{
          color: 'rgba(255,255,255,0.9)'
        }} data-id="element-17">
            Porque mereces ser mamá{' '}
            <span style={{
            color: 'var(--color-gold)'
          }} data-id="element-18">
              Y ser tú misma.
            </span>
          </p>
        </div>
      </div>
    </section>;
}